import { render, staticRenderFns } from "./DHXBJS.vue?vue&type=template&id=1507c0a1&scoped=true&"
import script from "./DHXBJS.vue?vue&type=script&lang=js&"
export * from "./DHXBJS.vue?vue&type=script&lang=js&"
import style0 from "./DHXBJS.vue?vue&type=style&index=0&id=1507c0a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507c0a1",
  null
  
)

export default component.exports